'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formatter = require('../common/formatter');

var _service = require('./service');

var _util = require('./util');

var _formFieldUtils = require('../common/formFieldUtils');

var _service2 = require('../common/oss-upload-helper/service');

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DEFAULTURL = '/form/region/getRouteRegion';
var DEFAULTURLLEVEL = '/form/region/getRouteRegionLevel';
var DEFAULT_CATALOG_ID = 330000;
function walkTree(options, cache) {
  if (!cache) cache = {};

  if (options === null || options === undefined || !options.map) {
    return cache;
  }

  options.filter(function (item) {
    return !!item;
  }).forEach(function (item) {
    cache[item.value] = {
      label: item.text || item.label || item.value,
      value: item.value
    };
    if (!(0, _lodash.isEmpty)(item.children)) {
      walkTree(item.children, cache);
    }
  });

  return cache;
}

var RegionSelectField = (_temp = _class = function (_Field) {
  _inherits(RegionSelectField, _Field);

  function RegionSelectField(props) {
    _classCallCheck(this, RegionSelectField);

    // 用本地数据源构造地址 cache
    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    var localOptions = _this.getLocalOptions();
    _this.regionCache = walkTree(localOptions) || {};
    var defaultValue = _this.getFieldValue() || null;
    var dataSource = props.dataSource;

    _this.state = _extends({}, _this.state, {
      dataSource: [],
      localOptions: localOptions,
      optionVisible: false,
      buttonDisabled: false,
      defaultValue: defaultValue,
      asyncUrl: (0, _lodash.isEmpty)(dataSource.url) ? DEFAULTURL : dataSource.url,
      defaultLevel: 1,
      maxLevel: 7
    });
    _this.renderButton = _this.renderButton.bind(_this);
    _this.onVisibleChange = _this.onVisibleChange.bind(_this);
    _this.selectRegion = _this.selectRegion.bind(_this);
    return _this;
  }

  RegionSelectField.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    if (this.isAsyncOptions()) {
      this.onLoadData();
    }
  };

  RegionSelectField.prototype.componentDidUpdate = function componentDidUpdate() {
    // 如果 fieldData.value[last].extra 里面有 matterId
    // 且 fieldData.matterId 为空，则将 matterId 赋值给 fieldData
    var matterId = void 0;
    var _props = this.props,
        value = _props.fieldData.value,
        prevMatterId = _props.matterId,
        $state = _props.$state;

    if (!(0, _lodash.isEmpty)(value)) {
      try {
        matterId = JSON.parse(value[value.length - 1].extra).matterId;
      } catch (e) {
        // do nothing
      }
      if (matterId && matterId !== prevMatterId) {
        $state.set('matterId', matterId);
      }
    }
  };

  RegionSelectField.prototype.isAsyncOptions = function isAsyncOptions() {
    var dataSource = this.props.dataSource;

    return dataSource.type === 'ASYNC' ? true : false;
  };

  RegionSelectField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-region'
    });
  };

  /**
   * 获取组件的选项
   */
  RegionSelectField.prototype.getLocalOptions = function getLocalOptions() {
    var _props$dataSource = this.props.dataSource,
        dataSource = _props$dataSource === undefined ? {} : _props$dataSource;

    return (0, _util.parseOptions)(dataSource.options);
  };

  // onChange时触发，组件的值向全局store中赋值时的转换


  RegionSelectField.prototype.formatOut = function formatOut(value, data, extra) {
    return (0, _formatter.formatOut)(value, 'RegionSelect', data, extra);
  };

  RegionSelectField.prototype.fieldDataFormatter = function fieldDataFormatter(value) {
    var options = this.getRealOptions();
    return (0, _formatter.fieldDataFormatter)(value, 'RegionSelect', options);
  };

  RegionSelectField.prototype.defaultValueFormatter = function defaultValueFormatter(value) {
    if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
      return value.map(function (item) {
        return item.text;
      }).join('/');
    }
    return value;
  };

  /**
   * 当前选中的节点数据 value/label/children/pos
   * 返回下一层的数据，然后自行拼装完整的数据
   */
  /**
   * 33318480: 联办事项中以props中获取的regionRouteId作为目录Code
   */


  RegionSelectField.prototype.selectRegion = function selectRegion() {
    var defaultValue = this.getFieldValue();
    this.setState({ defaultValue: (0, _lodash.cloneDeep)(defaultValue) });
    this.setState({ optionVisible: false });
  };

  RegionSelectField.prototype.renderButton = function renderButton() {
    var buttonDisabled = this.state.buttonDisabled;

    return _react2.default.createElement(
      'div',
      { className: 'region-footer-button' },
      _react2.default.createElement(
        _next.Button,
        { type: 'primary', onClick: this.selectRegion, disabled: buttonDisabled },
        '\u786E\u5B9A'
      )
    );
  };

  RegionSelectField.prototype.onVisibleChange = function onVisibleChange(visible, type) {
    // console.log(visible, type);
    var onChange = this.props.onChange;
    var defaultValue = this.state.defaultValue;

    if (type === 'fromCascader') {
      return false;
    } else if (type === 'docClick') {
      onChange({ value: (0, _lodash.cloneDeep)(defaultValue) });
    }
    this.setState({ optionVisible: visible });
  };

  RegionSelectField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var _props2 = this.props,
        _onChange = _props2.onChange,
        isMustSelectLeaf = _props2.isMustSelectLeaf,
        notFoundContent = _props2.notFoundContent,
        _props2$autoWidth = _props2.autoWidth,
        autoWidth = _props2$autoWidth === undefined ? false : _props2$autoWidth,
        $state = _props2.$state;
    var optionVisible = this.state.optionVisible;

    var controlProps = this.getControlProps();
    var listStyle = (0, _formFieldUtils.isIE)() ? { width: '150px' } : { minWidth: '150px', width: 'auto' };
    if (autoWidth) {
      var cascadeSize = 3; // this.getCascadeSize();
      listStyle = { width: 1 / cascadeSize * 100 + '%' };
    }
    // console.log(this.getFieldValue())
    var fieldProps = _extends({}, controlProps, {
      notFoundContent: notFoundContent,
      autoWidth: autoWidth,
      listStyle: listStyle,
      dataSource: this.getRealOptions(),
      valueRender: function valueRender(item) {
        var fieldValue = _this2.getFieldValue();
        if (!(0, _lodash.isEmpty)(fieldValue)) {
          return fieldValue.map(function (item) {
            if (item && (item.text || item.label) && item.text !== item.value) {
              return item.text || item.label;
            } else if (item && item.value) {
              return _this2.regionCache[item.value] && _this2.regionCache[item.value]['label'] || item.value;
            } else {
              return item || '';
            }
          }).join('/');
        }
        return '';
      },
      canOnlyCheckLeaf: isMustSelectLeaf,
      style: _extends({}, controlProps.style, { width: '100%' }),
      onChange: function onChange(value, data, extra) {
        // console.log(value, data, extra, this.formatOut(value, data, extra), 20000000);
        if (!value) {
          _onChange({ value: null });
          _this2.setState({ defaultValue: null });
          return false;
        }
        if (data.selectFlag == 'SELF') {
          _this2.setState({ buttonDisabled: false });
          _onChange({ value: _this2.formatOut(value, data, extra) });
          $state.set('matterId', data.matterId);
        } else if (data.selectFlag == 'ONLY_CHILD') {
          _this2.setState({ buttonDisabled: true });
          _onChange({ value: null });
        }
      }
    });
    if (this.isAsyncOptions()) {
      fieldProps.loadData = this.onLoadData;
    }
    // console.log(fieldProps, this.props, optionVisible);
    return _react2.default.createElement(_next.CascaderSelect, _extends({
      changeOnSelect: true,
      onVisibleChange: this.onVisibleChange,
      footer: this.renderButton(),
      visible: optionVisible
    }, fieldProps));
  };

  return RegionSelectField;
}(_vuFusionField2.default), _class.displayName = 'RegionSelect', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  notFoundContent: '无选项',
  autoWidth: false
}), _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getRealOptions = function () {
    return _this3.isAsyncOptions() ? _this3.state.dataSource : _this3.state.localOptions;
  };

  this.onLoadData = function (selected) {
    var _state = _this3.state,
        prevDataSource = _state.dataSource,
        asyncUrl = _state.asyncUrl,
        defaultLevel = _state.defaultLevel,
        maxLevel = _state.maxLevel;
    var _props3 = _this3.props,
        fieldId = _props3.fieldId,
        global = _props3.global,
        regionRouteId = _props3.regionRouteId,
        rootCatalogId = _props3.rootCatalogId;

    var requestParams = (0, _service2.initRequestParams)(fieldId, global);
    var dataSource = (0, _lodash.cloneDeep)(prevDataSource);
    // @author 兴会 根据岳飞沟通，这一版先写死DEFAULT_CATALOG_ID，浙江省本级
    // @author 古樾 根据需求修改。https://aone.alibaba-inc.com/req/35197975
    // @describe 优先级: 已选取的值 > G端设计器配置的rootCatalogId > DEFAULT_CATALOG_ID
    // @warning 建议不要删除DEFAULT_CATALOG_ID，老逻辑都依赖这个字段
    var code = selected ? selected.value : rootCatalogId ? rootCatalogId : DEFAULT_CATALOG_ID;
    // 测试categroyCode: 101300493
    var params = {
      categoryCode: regionRouteId || requestParams.matterId,
      sequenceNo: requestParams.sequenceNo,
      parentCode: selected ? code : null,
      currentCode: selected ? null : code,
      asyncUrl: asyncUrl //默认的路径
    };
    return (0, _service.queryRegion)(params).then(function (data) {
      if ((0, _lodash.isEmpty)(data)) {
        return false;
      }
      var options = (0, _util.convertDataSource)(data, maxLevel);
      // 下拉框第一级数据
      if (!selected) {
        dataSource = options;
        (0, _service.queryRegionLevel)({ asyncUrl: DEFAULTURLLEVEL }).then(function (level) {
          _this3.setState({ defaultLevel: level });
          _this3.setState({ maxLevel: data[0].level + level - 1 });
        });
      } else {
        var pos = selected.pos.split('-');
        pos.shift();
        var current = pos.reduce(function (source, current, index) {
          return index === pos.length - 1 ? source[current] : source[current].children;
        }, dataSource);
        current.children = options;
      }
      _this3.setState({ dataSource: dataSource });
    });
  };
}, _temp);
exports.default = RegionSelectField;
module.exports = exports['default'];